import { useLayoutEffect, useRef, useState } from 'react'
import { createPortal } from 'react-dom'
import { useTranslation } from 'react-i18next'
import { Transition } from 'react-transition-group'

import { useAppLayout } from '@/components/AppLayout/AppLayoutProvider'
import Button from '@/components/Button/Button'
import { useAppState } from '@/composables/useAppState'
import { useRunnerUITransition } from '@/composables/useRunnerUITransition'
import useTracking from '@/composables/useTracking'
import { CompletionStatus } from '@/state/AppStateMachine'

export default function SummaryFooterRight() {
  const { t } = useTranslation()

  const { actor, summary, scenario, persona, state } = useAppState()

  const { footerRight } = useAppLayout()

  const { trackClick } = useTracking()

  const buttonRef = useRef<HTMLDivElement>(null)
  const { timeout, onEnter, onExit } = useRunnerUITransition(buttonRef, {
    from: 'bottom',
    yPercent: 125,
    delayEnter: 0.7,
  })

  const [isSmall, setIsSmall] = useState(true)
  const [hasReachEnd, setHasReachEnd] = useState(false)
  const isContent = state.matches('summary.content')

  useLayoutEffect(() => {
    const onResize = () => {
      setIsSmall(window.innerWidth < 768)
    }
    onResize()
    window.addEventListener('resize', onResize)
    return () => window.removeEventListener('resize', onResize)
  }, [setIsSmall])

  useLayoutEffect(() => {
    const onScroll = () => {
      if (isContent) {
        if (window.scrollY + window.innerHeight >= document.body.scrollHeight - 100) {
          // console.log('reach end');
          setHasReachEnd(true)
        }
      }
    }
    onScroll()
    window.addEventListener('scroll', onScroll)
    return () => window.removeEventListener('scroll', onScroll)
  }, [isContent])

  const hasNotStartedScenarios = scenario.status.some((status) => status === CompletionStatus.NOT_STARTED)
  const hasNext = isContent && hasNotStartedScenarios && (!isSmall || hasReachEnd)

  const onClickNext = () => {
    trackClick({
      clickType: 'button',
      unitName: `${persona}_simulation_${summary.scenario}`,
      unitVariation: 'summary',
      unitLocation: 'tyce',
      buttonText: 'continue',
      buttonName: 'navigation_button',
    })
    actor.send({ type: 'NEXT' })
  }

  return (
    footerRight?.current &&
    createPortal(
      <Transition
        nodeRef={buttonRef}
        in={hasNext}
        mountOnEnter
        unmountOnExit
        onEnter={onEnter}
        onExit={onExit}
        timeout={timeout}
      >
        <div ref={buttonRef}>
          <Button onClick={onClickNext}>{t('global.continue')}</Button>
        </div>
      </Transition>,
      footerRight.current
    )
  )
}
